document.addEventListener('DOMContentLoaded', () => {
  'use strict';

  const designer = document.querySelector('[data-me-designer]');
  const productForm = document.querySelector('.me-main-product__form');

  if (!designer || !productForm) return;

  const rules = window.MEPlacementRules?.placements || {};
  const selectedSize = () => String(
    designer.querySelector('[data-me-size-property]')?.value || ''
  ).trim();

  const selectedColor = () => String(
    designer.querySelector('[data-me-selected-color]')?.textContent || ''
  ).replace(/^Selected:\s*/i, '').trim();

  const selectedPlacements = () => Array.from(
    designer.querySelectorAll('[data-me-placement-checkbox]:checked')
  ).map((input) => input.value);

  const quantity = () => Math.max(
    1,
    Number.parseInt(
      designer.querySelector('[data-me-quantity-input]')?.value || '1',
      10
    ) || 1
  );

  const proofRequested = () => Boolean(
    designer.querySelector('[data-me-proof-checkbox]')?.checked ||
    designer.querySelector('input[name="properties[Digital Proof Requested]"]')?.checked
  );

  const authorizationConfirmed = () => Boolean(
    designer.querySelector('[data-me-rights-checkbox]')?.checked ||
    designer.querySelector('input[name="properties[Artwork Authorization]"]')?.checked
  );

  function makeId() {
    if (window.crypto?.randomUUID) {
      return `ME-${window.crypto.randomUUID()}`;
    }

    return `ME-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
  }

  function getOrCreateInput(name) {
    let input = productForm.querySelector(`input[name="${CSS.escape(name)}"]`);

    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      productForm.appendChild(input);
    }

    return input;
  }

  function placementSpecification(name) {
    const placement = rules[name] || {};
    const dimensions = placement.dimensions || 'Standard production size';
    const instructions = placement.instructions || 'Standard production placement';

    return `${name}: ${dimensions} — ${instructions}`;
  }

  function buildPacket() {
    const placements = selectedPlacements();
    const packetIdInput = getOrCreateInput('properties[Production Packet ID]');

    if (!packetIdInput.value) {
      packetIdInput.value = makeId();
    }

    const artworkSummary = window.MEArtworkManager?.getSummary?.() || [];
    const artworkLines = artworkSummary.map((item) => {
      const label = item.placement || 'Artwork';
      const summary = item.summary || item.type || 'Assigned';
      return `${label}: ${summary}`;
    });

    const summary = [
      `Color: ${selectedColor() || 'Not selected'}`,
      `Size: ${selectedSize() || 'Not selected'}`,
      `Quantity: ${quantity()}`,
      `Locations: ${placements.join(', ') || 'None'}`,
      `Proof: ${proofRequested() ? 'Requested — approval required before production' : 'Not requested'}`,
      `Authorization: ${authorizationConfirmed() ? 'Confirmed' : 'Not confirmed'}`
    ].join(' | ');

    getOrCreateInput('properties[Production Summary]').value = summary;
    getOrCreateInput('properties[Production Print Specifications]').value =
      placements.map(placementSpecification).join(' | ');
    getOrCreateInput('properties[Production Artwork Assignments]').value =
      artworkLines.join(' | ') || 'No artwork summary available';
    getOrCreateInput('properties[Production Proof Status]').value =
      proofRequested()
        ? 'Hold production until email approval is received'
        : 'Standard production review';
    getOrCreateInput('properties[Production Template System]').value =
      'Moments Etched standardized garment template';

    renderReviewPacket({
      packetId: packetIdInput.value,
      placements,
      artworkLines
    });
  }

  function renderReviewPacket({ packetId, placements, artworkLines }) {
    const reviewPanel = designer.querySelector('[data-me-step-panel="review"]');
    if (!reviewPanel) return;

    let card = reviewPanel.querySelector('[data-me-production-packet-card]');

    if (!card) {
      card = document.createElement('section');
      card.className = 'me-review-summary me-production-packet';
      card.dataset.meProductionPacketCard = 'true';

      const confirmations = reviewPanel.querySelector('.me-review-confirmations');
      if (confirmations) {
        confirmations.insertAdjacentElement('beforebegin', card);
      } else {
        reviewPanel.appendChild(card);
      }
    }

    const specificationRows = placements.map((name) => {
      const placement = rules[name] || {};
      return `
        <div class="me-production-packet__row">
          <div>
            <strong>${escapeHtml(name)}</strong>
            <span>${escapeHtml(placement.instructions || 'Standard placement')}</span>
          </div>
          <b>${escapeHtml(placement.dimensions || 'Standard')}</b>
        </div>
      `;
    }).join('');

    card.innerHTML = `
      <div class="me-review-summary__heading">
        <p>Production</p>
        <h4>Production-ready summary</h4>
      </div>

      <div class="me-production-packet__meta">
        <span>Packet ID</span>
        <strong>${escapeHtml(packetId)}</strong>
      </div>

      <div class="me-production-packet__grid">
        <div><span>Color</span><strong>${escapeHtml(selectedColor() || 'Not selected')}</strong></div>
        <div><span>Size</span><strong>${escapeHtml(selectedSize() || 'Not selected')}</strong></div>
        <div><span>Quantity</span><strong>${quantity()}</strong></div>
        <div><span>Proof</span><strong>${proofRequested() ? 'Requested' : 'Not requested'}</strong></div>
      </div>

      <div class="me-production-packet__locations">
        ${specificationRows || '<p>No print locations selected.</p>'}
      </div>

      <p class="me-production-packet__note">
        Final production centering may be adjusted slightly for garment size,
        collar position, seams, and print-method requirements.
      </p>
    `;
  }

  function escapeHtml(value) {
    return String(value || '')
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  }

  const style = document.createElement('style');
  style.textContent = `
    .me-production-packet__meta,
    .me-production-packet__row {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      gap: 14px;
    }

    .me-production-packet__meta {
      margin-top: 14px;
      padding: 11px 12px;
      border-radius: 10px;
      background: #f5f1ea;
      color: #706a64;
      font-size: 10px;
    }

    .me-production-packet__meta strong {
      color: #292521;
      text-align: right;
      overflow-wrap: anywhere;
    }

    .me-production-packet__grid {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 10px;
      margin-top: 14px;
    }

    .me-production-packet__grid > div {
      padding: 11px;
      border: 1px solid #e5ddd2;
      border-radius: 10px;
      background: #fffdfa;
    }

    .me-production-packet__grid span,
    .me-production-packet__row span {
      display: block;
      color: #7a736c;
      font-size: 9px;
      line-height: 1.4;
    }

    .me-production-packet__grid strong,
    .me-production-packet__row strong {
      display: block;
      margin-top: 3px;
      color: #292521;
      font-size: 11px;
    }

    .me-production-packet__locations {
      display: grid;
      gap: 8px;
      margin-top: 14px;
    }

    .me-production-packet__row {
      padding: 11px 12px;
      border-radius: 10px;
      background: #f5f1ea;
    }

    .me-production-packet__row b {
      flex: 0 0 auto;
      color: #a77f43;
      font-size: 10px;
    }

    .me-production-packet__note {
      margin: 14px 0 0;
      padding: 11px 12px;
      border-left: 3px solid #b08d57;
      background: #fbf5eb;
      color: #6b6259;
      font-size: 10px;
      line-height: 1.5;
    }

    @media screen and (max-width: 749px) {
      .me-production-packet__grid {
        grid-template-columns: 1fr;
      }
    }
  `;
  document.head.appendChild(style);

  window.addEventListener('me:placements-updated', buildPacket);
  window.addEventListener('me:artwork-updated', buildPacket);
  window.addEventListener('me:designer-variant-changed', buildPacket);
  window.addEventListener('me:variant-selection-state', buildPacket);

  designer.querySelectorAll('[data-me-proof-checkbox], [data-me-rights-checkbox]').forEach((input) => {
    input.addEventListener('change', buildPacket);
  });

  productForm.addEventListener('submit', buildPacket, { capture: true });

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-me-step-button="review"]')) {
      window.setTimeout(buildPacket, 80);
    }
  });

  buildPacket();
});
